import { Component, OnInit, ViewChild } from '@angular/core';
import { UserService } from 'src/app/services/user.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { getToken, CONSTANTES } from 'src/app/shared/global';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { Router } from '@angular/router';
import { MenuComponent } from 'src/app/core/menu/menu.component';
import { DataOrder } from 'src/app/models/DataOrder';
import { OrderService } from 'src/app/services/order.service';
import { Order } from 'src/app/models/Order';
import { ToastrService } from 'ngx-toastr';
import { MenuIndividualComponent } from 'src/app/core/menu-individual/menu-individual.component'
import { BehaviorSubject } from 'rxjs';
import { MenuItemService } from 'src/app/services/menu.item.service';
import { MessagesService } from 'src/app/services/messages.service';
import { HttpClient, HttpHandler } from '@angular/common/http';

declare var jQuery: any;

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {
  @ViewChild(MenuComponent) menuComponent: MenuComponent;

  public username: string;
  public id: number;
  public nid: string;
  public cip: string;
  public firstName: string;
  public lastName: string;
  public roles: string;
  public phone: string;
  public email: string;
  public addresses: string;
  public imagenesLogin = CONSTANTES.imagenesLogin;
  public logoDefensa = CONSTANTES.logoDefensa;
  public homeImage = CONSTANTES.homeImage;
  public savedOrder: Order;
  public menu: MenuIndividualComponent;


  constructor(private userService: UserService, private Spinner: NgxSpinnerService,
    private authService: AuthenticationService, private router: Router, private orderService: OrderService,
    private toastr: ToastrService) { }

  ngOnInit() {

    try{
      this.Spinner.show();
      jQuery.getScript(CONSTANTES.menu);
      this.nid = localStorage.getItem("nid");
      this.firstName = localStorage.getItem("firstName");
      this.lastName = localStorage.getItem("lastName");
      this.roles = localStorage.getItem("roles");
      this.roles = JSON.parse(this.roles);
      this.phone = localStorage.getItem("phone");
      this.email = localStorage.getItem("email");
      this.addresses = localStorage.getItem("addresses");
      this.addresses = JSON.parse(this.addresses);
      this.getOrder();
    } catch(Error){
      this.router.navigate(['login']);
    }

  }

  getUserInfo() {
    this.Spinner.show();
    this.userService.getUser(localStorage.getItem("nid")).subscribe(
      data => {
        if (getToken(data)) {
          this.nid = localStorage.getItem("nid");

          this.Spinner.hide();

        } else {
          let infoUser = {
            userName: localStorage.getItem("nid")
          }
          this.authService.logOut(infoUser).subscribe(
            () => {
              localStorage.clear();
              this.router.navigate(['login']);
            },
            () => {
              this.router.navigate(['login']);
            }
          );
        }
      }, () => {
        let infoUser = {
          userName: localStorage.getItem("nid")
        }
        this.authService.logOut(infoUser).subscribe(
          () => {
            localStorage.clear();
            this.router.navigate(['login']);
          },
          () => {
            this.router.navigate(['login']);
          }
        );
      })
  }

  // Función para obtener los pedidos guardados del usuario
  getOrder(){
    let dataOrder: DataOrder = {
      domain: null,
      errorCode: null,
      id: null,
      user: null,
      nid: this.nid,
      orders: null,
      status: null,
      receiptOrders: null,
      dataBank: null,
      token: null,
      orderNumberBank: null,
      orderPending: null,
      pdfName: null,
      role: localStorage.getItem("role"),
      noc: null
    }
    this.orderService.getOrdersToConfirm(dataOrder).subscribe(
      data => {
        if (getToken(data)){
          if (data.orders !== null && data.orders.length > 0) {
            this.savedOrder = data.orders[0];
            if(this.savedOrder.orderType != 'TIENDA_FISICA'){
              localStorage.setItem("articulos", this.savedOrder.orderDetails.length.toString());
              this.orderService.sendUpdate(this.savedOrder.orderDetails.length.toString());
              this.orderService.changeTime(this.savedOrder.confirmDate.toString());
              this.orderService.changeStatus(this.savedOrder.status);
            }else{
              localStorage.setItem("articulos", null);
              this.orderService.sendUpdate("0");  
              this.orderService.changeTime(null);
              this.orderService.changeStatus(null);
            }
            //this.orderService.currentArticles = new BehaviorSubject(this.savedOrder.orderDetails.length.toString()).asObservable();
          }
          this.Spinner.hide();
        } else {
          this.toastr.warning(data.errorCode.message, "ERROR");
          this.Spinner.hide();
        }
      }, error => {
        this.toastr.error(error);
        this.logOut();
      }
    );
  }

  logOut() {
    let infoUser = {
      userName: localStorage.getItem("nid")
    }
    this.authService.logOut(infoUser).subscribe(
      data => {
        localStorage.clear();
        this.router.navigate(['login']);
      }
    );
  }

}
